module.exports = __webpack_public_path__ + "img/960x540 Cement 3.6a9bfc85.png";